/* NOMAD STUDIO theme JS */
(function(){
  'use strict';
  function $(s, r){ return (r||document).querySelector(s); }
  function $$(s, r){ return Array.from((r||document).querySelectorAll(s)); }
  /* Shopify's JSON APIs (cart.js, product.variants | json) ALWAYS return prices in cents,
     regardless of the currency's decimal setting. So we ALWAYS divide by 100.
     For zero-decimal currencies (IDR, JPY, KRW...) we then round + format without decimals. */
  var ZERO_DECIMAL_LIST = ['IDR','JPY','KRW','VND','CLP','ISK','CRC','HUF','TWD','KMF','PYG','RWF','UGX','XAF','XOF','XPF','BIF','DJF','GNF','MGA'];
  function money(cents){
    var symbol = window.NOMAD_CURRENCY_SYMBOL || '$';
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    var isZeroDecimal = ZERO_DECIMAL_LIST.indexOf(currency) > -1;
    var major = Number(cents) / 100;
    var formatted;
    if (isZeroDecimal) {
      formatted = Math.round(major).toLocaleString('en-US').replace(/,/g, '.');
    } else {
      var rounded = Math.round(major * 100) / 100;
      formatted = rounded % 1 === 0
        ? rounded.toLocaleString('en-US')
        : rounded.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    return symbol + ' ' + formatted;
  }

  var IS_LOGGED_IN = window.NOMAD_LOGGED_IN === true;
  var ACCOUNT_LOGIN_URL = window.NOMAD_LOGIN_URL || '/account/login';

  /* ---------- Wishlist (localStorage-based, login-gated) ---------- */
  var WL_KEY = 'nomad_wishlist';
  function getWishlist(){
    try { return JSON.parse(localStorage.getItem(WL_KEY) || '[]'); } catch(e){ return []; }
  }
  function saveWishlist(arr){
    try { localStorage.setItem(WL_KEY, JSON.stringify(arr)); } catch(e){}
  }
  function isWished(handle){ return getWishlist().indexOf(handle) !== -1; }
  function toggleWish(handle){
    var wl = getWishlist();
    var idx = wl.indexOf(handle);
    if (idx === -1) wl.push(handle); else wl.splice(idx, 1);
    saveWishlist(wl);
    updateWishUI();
    return idx === -1;
  }
  function updateWishUI(){
    var wl = getWishlist();
    $$('[data-wish-toggle]').forEach(function(btn){
      var handle = btn.dataset.wishToggle;
      btn.classList.toggle('active', wl.indexOf(handle) !== -1);
    });
    var count = wl.length;
    $$('[data-wish-count]').forEach(function(el){
      el.textContent = count > 0 ? count : '';
    });
  }
  function bindWishlist(){
    $$('[data-wish-toggle]').forEach(function(btn){
      if (btn._wishBound) return;
      btn._wishBound = true;
      btn.addEventListener('click', function(e){
        e.preventDefault(); e.stopPropagation();
        var handle = btn.dataset.wishToggle;
        if (!handle) return;
        if (!IS_LOGGED_IN) {
          var next = encodeURIComponent(window.location.href);
          window.location.href = ACCOUNT_LOGIN_URL + '?return_to=' + next;
          return;
        }
        toggleWish(handle);
      });
    });
    /* Wishlist page link (heart icon in header): navigates freely to /pages/wishlist.
       The page itself shows a maintenance state — no login gate needed for viewing.
       (The `data-wish-toggle` handler above still gates ADDING to wishlist behind login.) */
  }
  updateWishUI();
  bindWishlist();

  /* ---------- Mobile menu ---------- */
  var mobileMenu = $('#mobile-menu');
  var hamburger = $('#hd-hamburger');
  var mmClose = $('#mm-close');
  function closeMenu(){
    if (!mobileMenu) return;
    mobileMenu.classList.remove('open');
    if (hamburger) hamburger.classList.remove('open');
    document.body.style.overflow = '';
  }
  function openMenu(){
    if (!mobileMenu) return;
    mobileMenu.classList.add('open');
    if (hamburger) hamburger.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  if (hamburger) hamburger.addEventListener('click', function(){
    if (mobileMenu.classList.contains('open')) closeMenu(); else openMenu();
  });
  if (mmClose) mmClose.addEventListener('click', closeMenu);
  if (mobileMenu) $$('a', mobileMenu).forEach(function(a){ a.addEventListener('click', closeMenu); });

  /* ---------- Cart drawer ---------- */
  var drawer = $('#cart-drawer');
  var cartCountEls = $$('[data-cart-count]');
  function updateCartCount(count){
    cartCountEls.forEach(function(el){ el.textContent = count > 0 ? count : ''; });
  }
  function fetchCart(){
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function(r){ return r.json(); });
  }
  /* Zero-decimal currency detection: cart.total_price is in major units for these, cents for others */
  var ZERO_DECIMAL_CURRENCIES = ['IDR','JPY','KRW','VND','CLP','ISK','CRC','HUF','TWD','KMF','PYG','RWF','UGX','XAF','XOF','XPF','BIF','DJF','GNF','MGA'];
  function isZeroDecimalCurrency(){
    var c = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    return ZERO_DECIMAL_CURRENCIES.indexOf(c) > -1;
  }
  function normalizeThreshold(rawThreshold){
    /* User enters threshold in major currency units (e.g. 500000 for Rp 500.000, or 50 for $50).
       cart.total_price is always in cents (× 100), so we always multiply. */
    return Number(rawThreshold) * 100;
  }

  function renderFreeShippingBar(cart){
    if (!drawer || drawer.dataset.fsEnable !== 'true') return '';
    var rawThreshold = parseInt(drawer.dataset.fsThreshold, 10);
    if (!rawThreshold || rawThreshold <= 0) return '';
    var threshold = normalizeThreshold(rawThreshold);
    var progress = Math.min(100, (cart.total_price / threshold) * 100);
    var remaining = Math.max(0, threshold - cart.total_price);
    var msg;
    if (remaining === 0) {
      msg = drawer.dataset.fsMsgReached || "You've unlocked free shipping!";
    } else {
      var msgTemplate = drawer.dataset.fsMsgBelow || "You're {amount} away from free shipping";
      msg = msgTemplate.replace('{amount}', money(remaining));
    }
    return '' +
      '<div class="cd-fs' + (remaining === 0 ? ' is-reached' : '') + '">' +
        '<div class="cd-fs-msg">' + msg + '</div>' +
        '<div class="cd-fs-track"><div class="cd-fs-fill" style="width:' + progress + '%"></div></div>' +
      '</div>';
  }

  var SHIP_KEY = 'nomad_shipping_zone';
  function getShippingZones(){
    var tag = drawer && drawer.querySelector('[data-ship-zones]');
    if (!tag) return [];
    try { return JSON.parse(tag.textContent) || []; } catch(e){ return []; }
  }
  function renderShippingEstimator(cart){
    if (!drawer || drawer.dataset.shipEnable !== 'true') return '';
    var zones = getShippingZones();
    if (!zones.length) return '';
    var heading = drawer.dataset.shipHeading || 'Estimate shipping';
    var placeholder = drawer.dataset.shipPlaceholder || 'Select your region';
    var saved = '';
    try { saved = localStorage.getItem(SHIP_KEY) || ''; } catch(e){}

    var options = zones.map(function(z){
      var sel = (z.name === saved) ? ' selected' : '';
      return '<option value="' + z.name + '" data-price="' + z.price + '"' + sel + '>' + z.name + '</option>';
    }).join('');

    var currentCost = '';
    if (saved) {
      var match = zones.filter(function(z){ return z.name === saved; })[0];
      if (match) currentCost = money(normalizeThreshold(match.price));
    }

    return '' +
      '<div class="cd-ship">' +
        '<div class="cd-ship-heading">' + heading + '</div>' +
        '<div class="cd-ship-row">' +
          '<select class="cd-ship-select" data-ship-select>' +
            '<option value="">' + placeholder + '</option>' +
            options +
          '</select>' +
          '<div class="cd-ship-cost" data-ship-cost>' + currentCost + '</div>' +
        '</div>' +
      '</div>';
  }

  function fetchUpsell(cart, cb){
    if (!drawer || drawer.dataset.upsellEnable !== 'true') { cb(''); return; }
    if (!cart.items.length) { cb(''); return; }
    var firstProductId = cart.items[0].product_id;
    var intent = drawer.dataset.upsellIntent || 'related';
    fetch('/recommendations/products.json?product_id=' + firstProductId + '&limit=4&intent=' + intent, { credentials: 'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(data){
        /* Filter out products already in cart */
        var inCartIds = cart.items.map(function(i){ return i.product_id; });
        var rec = (data.products || []).filter(function(p){ return inCartIds.indexOf(p.id) === -1 && p.available !== false; })[0];
        if (!rec) { cb(''); return; }
        var heading = drawer.dataset.upsellHeading || 'You might also like';
        var img = rec.featured_image ? '<img src="' + rec.featured_image + '" alt="" loading="lazy">' : '';
        var priceHtml = money(rec.price);
        cb('' +
          '<div class="cd-upsell">' +
            '<div class="cd-upsell-heading">' + heading + '</div>' +
            '<div class="cd-upsell-item">' +
              '<a href="' + rec.url + '" class="cd-upsell-thumb">' + img + '</a>' +
              '<div class="cd-upsell-info">' +
                '<a href="' + rec.url + '" class="cd-upsell-name">' + rec.title + '</a>' +
                '<div class="cd-upsell-price">' + priceHtml + '</div>' +
              '</div>' +
              '<button type="button" class="cd-upsell-add" data-upsell-add="' + (rec.variants[0] && rec.variants[0].id) + '" aria-label="Add ' + rec.title + '">+</button>' +
            '</div>' +
          '</div>');
      })
      .catch(function(){ cb(''); });
  }

  function renderCart(cart){
    updateCartCount(cart.item_count);
    var body = $('#cd-body'); var footer = $('#cd-footer');
    if (!body || !footer) return;
    if (cart.item_count === 0){
      body.innerHTML = '<div class="cd-empty">Your bag is empty.</div>';
      footer.innerHTML = '';
      return;
    }
    var lines = cart.items.map(function(item){
      var variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<div class="cd-variant">' + item.variant_title + '</div>' : '';
      var img = item.image ? '<img src="' + item.image + '" alt="" loading="lazy">' : '';
      return '' +
        '<div class="cd-line" data-key="' + item.key + '">' +
          '<div class="cd-thumb">' + img + '</div>' +
          '<div>' +
            '<div class="cd-name">' + item.product_title + '</div>' +
            variant +
            '<div class="cd-controls">' +
              '<div class="cd-qty">' +
                '<button type="button" data-qty="-">−</button>' +
                '<input type="text" value="' + item.quantity + '" readonly>' +
                '<button type="button" data-qty="+">+</button>' +
              '</div>' +
              '<button type="button" class="cd-remove" data-remove>Remove</button>' +
            '</div>' +
          '</div>' +
          '<div class="cd-price">' + money(item.final_line_price) + '</div>' +
        '</div>';
    }).join('');
    body.innerHTML = renderFreeShippingBar(cart) + lines;
    footer.innerHTML =
      '<div class="cd-upsell-slot"></div>' +
      renderShippingEstimator(cart) +
      '<div class="cd-subtotal"><span>Subtotal</span><span>' + money(cart.items_subtotal_price) + '</span></div>' +
      '<p class="cd-duties">' + (drawer && drawer.dataset.dutiesNote ? drawer.dataset.dutiesNote : '') + '</p>' +
      /* payment note is only populated for non-Indonesian visitors */
      (drawer && drawer.dataset.paymentNote
        ? '<p class="cd-payment-note">' + drawer.dataset.paymentNote + '</p>' : '') +
      '<a href="/checkout" class="cd-checkout">Checkout →</a>';

    /* Shipping estimator change handler */
    var shipSelect = footer.querySelector('[data-ship-select]');
    var shipCost = footer.querySelector('[data-ship-cost]');
    if (shipSelect && shipCost) {
      shipSelect.addEventListener('change', function(){
        var opt = shipSelect.options[shipSelect.selectedIndex];
        var price = opt ? parseInt(opt.dataset.price, 10) : 0;
        if (shipSelect.value && !isNaN(price)) {
          shipCost.textContent = money(normalizeThreshold(price));
          try { localStorage.setItem(SHIP_KEY, shipSelect.value); } catch(e){}
        } else {
          shipCost.textContent = '';
          try { localStorage.removeItem(SHIP_KEY); } catch(e){}
        }
      });
    }

    fetchUpsell(cart, function(html){
      var slot = $('.cd-upsell-slot');
      if (slot) slot.innerHTML = html;
      /* Bind add-to-cart click on upsell */
      var addBtn = $('[data-upsell-add]');
      if (addBtn) {
        addBtn.addEventListener('click', function(){
          var vid = addBtn.dataset.upsellAdd;
          addBtn.disabled = true;
          fetch('/cart/add.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
          }).then(function(){ fetchCart().then(renderCart); });
        });
      }
    });

    $$('.cd-line', body).forEach(function(line){
      var key = line.dataset.key;
      var input = $('input', line);
      $$('[data-qty]', line).forEach(function(btn){
        btn.addEventListener('click', function(){
          var delta = btn.dataset.qty === '+' ? 1 : -1;
          updateItem(key, Math.max(0, parseInt(input.value, 10) + delta));
        });
      });
      var rem = $('[data-remove]', line);
      if (rem) rem.addEventListener('click', function(){ updateItem(key, 0); });
    });
  }
  function updateItem(key, qty){
    fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function(r){ return r.json(); }).then(renderCart);
  }
  function openCart(){
    if (!drawer) return;
    drawer.classList.add('open');
    document.body.style.overflow = 'hidden';
    fetchCart().then(renderCart);
  }
  function closeCart(){
    if (!drawer) return;
    drawer.classList.remove('open');
    document.body.style.overflow = '';
  }
  $$('[data-cart-open]').forEach(function(el){
    el.addEventListener('click', function(e){ e.preventDefault(); openCart(); });
  });
  $$('[data-cart-close]').forEach(function(el){ el.addEventListener('click', closeCart); });
  var cartOverlay = $('.cd-overlay');
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && drawer && drawer.classList.contains('open')) closeCart();
  });
  fetchCart().then(function(cart){ updateCartCount(cart.item_count); });

  /* ---------- Product form ---------- */
  var productForm = $('#product-form');
  if (productForm){
    productForm.addEventListener('submit', function(e){
      e.preventDefault();
      var btn = $('button[type="submit"]', productForm);
      var orig = btn ? btn.innerHTML : '';
      if (btn){ btn.disabled = true; btn.innerHTML = 'Adding…'; }
      fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        body: new FormData(productForm)
      }).then(function(r){ return r.json(); }).then(function(){
        if (btn){ btn.disabled = false; btn.innerHTML = orig; }
        openCart();
      }).catch(function(){
        if (btn){ btn.disabled = false; btn.innerHTML = orig; }
        alert('Could not add to bag.');
      });
    });

    var variants = window.NOMAD_PRODUCT_VARIANTS || [];
    var vid = $('input[name="id"]', productForm);
    var priceEl = $('#pi-price-val');
    var compareEl = $('#pi-compare-val');
    $$('.pi-variant-options input[type="radio"]').forEach(function(inp){
      inp.addEventListener('change', function(){
        var v = variants.find(function(x){ return String(x.id) === inp.value; });
        if (v){
          if (vid) vid.value = v.id;
          if (priceEl) priceEl.textContent = money(v.price);
          if (compareEl){
            if (v.compare_at_price && v.compare_at_price > v.price){
              compareEl.textContent = money(v.compare_at_price);
              compareEl.style.display = 'inline';
            } else compareEl.style.display = 'none';
          }
        }
      });
    });
  }

  $$('.pi-qty [data-qty]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var input = btn.parentElement.querySelector('input');
      if (!input) return;
      var delta = btn.dataset.qty === '+' ? 1 : -1;
      input.value = Math.max(1, parseInt(input.value || '1', 10) + delta);
    });
  });

  /* ---------- Cart page qty ---------- */
  $$('.cart-form [data-qty]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var input = btn.parentElement.querySelector('input');
      if (!input) return;
      var delta = btn.dataset.qty === '+' ? 1 : -1;
      input.value = Math.max(0, parseInt(input.value || '1', 10) + delta);
      var form = btn.closest('form');
      if (form) form.submit();
    });
  });

  /* ---------- Product page gallery (single big image + progress dots + swipe) ---------- */
  var _pgIdx = 0;
  function initPGallery(){
    var main = $('#pg-main-img');
    var wrap = $('#pg-main');
    var progress = $$('.pg-progress span');
    var images = [];
    try { images = JSON.parse(wrap && wrap.dataset.images || '[]'); } catch(e){ return; }
    if (!main || !wrap || images.length < 2) return;

    images.forEach(function(src){ new Image().src = src; });

    function setActive(i){
      if (i < 0) i = images.length - 1;
      if (i >= images.length) i = 0;
      _pgIdx = i;
      main.classList.add('loading');
      main.removeAttribute('srcset');
      main.src = images[i];
      if (main.decode) main.decode().then(function(){ main.classList.remove('loading'); }).catch(function(){ main.classList.remove('loading'); });
      else main.onload = function(){ main.classList.remove('loading'); };
      progress.forEach(function(p, k){ p.classList.toggle('active', k === i); });
    }

    progress.forEach(function(p, i){
      if (p._bound) return; p._bound = true;
      p.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); setActive(i); });
    });

    if (!wrap._swipe){
      wrap._swipe = true;
      var sx = 0, sy = 0;
      wrap.addEventListener('touchstart', function(e){ sx = e.changedTouches[0].screenX; sy = e.changedTouches[0].screenY; }, { passive: true });
      wrap.addEventListener('touchend', function(e){
        var dx = e.changedTouches[0].screenX - sx;
        var dy = e.changedTouches[0].screenY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setActive(_pgIdx + (dx < 0 ? 1 : -1));
        }
      }, { passive: true });
    }
  }
  initPGallery();

  /* ---------- Product card image swipe (grid) ---------- */
  function initCardSwipe(){
    $$('.pcell').forEach(function(cell){
      if (cell._cardSwipe) return;
      var pimg = cell.querySelector('.pimg');
      var track = cell.querySelector('.pimg-track');
      if (!pimg || !track) return;
      var slides = $$('.pimg-slide', track);
      if (slides.length < 2) return;
      cell._cardSwipe = true;

      var pimgLink = cell.querySelector('.pimg-link');
      var dots = $$('.pdots span', cell);
      var idx = 0;
      var count = slides.length;

      function setIdx(i, animate){
        if (i < 0) i = 0;
        if (i >= count) i = count - 1;
        idx = i;
        if (animate === false) track.classList.add('dragging');
        else track.classList.remove('dragging');
        track.style.transform = 'translateX(' + (-i * 100) + '%)';
        dots.forEach(function(d, k){ d.classList.toggle('active', k === i); });
      }

      /* Dot clicks */
      dots.forEach(function(dot, i){
        dot.addEventListener('click', function(e){
          e.preventDefault(); e.stopPropagation();
          setIdx(i, true);
        });
      });

      /* Touch drag — finger follows image */
      var sx = 0, sy = 0, dx = 0, dy = 0, swiping = false, locked = false, width = 0;

      pimg.addEventListener('touchstart', function(e){
        var t = e.changedTouches[0];
        sx = t.screenX; sy = t.screenY;
        dx = 0; dy = 0; swiping = false; locked = false;
        width = pimg.getBoundingClientRect().width;
      }, { passive: true });

      pimg.addEventListener('touchmove', function(e){
        var t = e.changedTouches[0];
        dx = t.screenX - sx;
        dy = t.screenY - sy;
        if (!locked) {
          if (Math.abs(dx) > 6 || Math.abs(dy) > 6) {
            locked = true;
            swiping = Math.abs(dx) > Math.abs(dy);
          }
        }
        if (swiping) {
          /* Add drag resistance at edges */
          var pct = dx / width * 100;
          if ((idx === 0 && dx > 0) || (idx === count - 1 && dx < 0)) pct = pct * 0.35;
          track.classList.add('dragging');
          track.style.transform = 'translateX(calc(' + (-idx * 100) + '% + ' + pct + '%))';
        }
      }, { passive: true });

      pimg.addEventListener('touchend', function(){
        if (swiping) {
          var threshold = width * 0.18;
          if (dx < -threshold) setIdx(idx + 1, true);
          else if (dx > threshold) setIdx(idx - 1, true);
          else setIdx(idx, true); /* snap back */
        }
        setTimeout(function(){ swiping = false; }, 50);
      }, { passive: true });

      /* Mouse drag on desktop (nice to have) */
      var mDown = false, mSx = 0, mDx = 0;
      pimg.addEventListener('mousedown', function(e){
        mDown = true; mSx = e.screenX; mDx = 0;
        width = pimg.getBoundingClientRect().width;
      });
      window.addEventListener('mousemove', function(e){
        if (!mDown) return;
        mDx = e.screenX - mSx;
        if (Math.abs(mDx) > 5) {
          swiping = true;
          var pct = mDx / width * 100;
          if ((idx === 0 && mDx > 0) || (idx === count - 1 && mDx < 0)) pct = pct * 0.35;
          track.classList.add('dragging');
          track.style.transform = 'translateX(calc(' + (-idx * 100) + '% + ' + pct + '%))';
        }
      });
      window.addEventListener('mouseup', function(){
        if (!mDown) return;
        mDown = false;
        if (swiping) {
          var threshold = width * 0.18;
          if (mDx < -threshold) setIdx(idx + 1, true);
          else if (mDx > threshold) setIdx(idx - 1, true);
          else setIdx(idx, true);
          setTimeout(function(){ swiping = false; }, 50);
        }
      });

      /* Suppress link click if user swiped */
      if (pimgLink) {
        pimgLink.addEventListener('click', function(e){
          if (swiping) { e.preventDefault(); e.stopPropagation(); swiping = false; }
        });
      }

      /* Init position */
      setIdx(0, true);
    });
  }
  initCardSwipe();

  /* ---------- View toggle (grid columns) ---------- */
  function applyView(target){
    var grid = $('.pgrid');
    if (grid) {
      if (target === '2') grid.classList.add('cols-2');
      else grid.classList.remove('cols-2');
    }
    $$('[data-view]').forEach(function(b){
      b.classList.toggle('active', b.dataset.view === target);
    });
  }
  $$('[data-view]').forEach(function(btn){
    if (btn._viewBound) return;
    btn._viewBound = true;
    btn.addEventListener('click', function(e){
      e.preventDefault(); e.stopPropagation();
      var target = btn.dataset.view;
      applyView(target);
      try { localStorage.setItem('nomad_view', target); } catch(e){}
    });
  });
  try {
    var savedView = localStorage.getItem('nomad_view');
    if (savedView === '2' || savedView === '4') applyView(savedView);
  } catch(e){}

  /* ---------- Color-siblings label preview on hover ---------- */
  $$('.pi-color-swatches-wrap').forEach(function(wrap){
    if (wrap._colorHover) return;
    wrap._colorHover = true;
    var label = wrap.querySelector('[data-active-color]');
    var activeSwatch = wrap.querySelector('.pi-color-swatch.is-active');
    var defaultName = activeSwatch ? (activeSwatch.dataset.name || '') : '';
    if (label && !label.textContent.trim() && defaultName) label.textContent = defaultName;
    wrap.querySelectorAll('.pi-color-swatch').forEach(function(sw){
      sw.addEventListener('mouseenter', function(){
        if (label && sw.dataset.name) label.textContent = sw.dataset.name;
      });
      sw.addEventListener('mouseleave', function(){
        if (label) label.textContent = defaultName;
      });
    });
  });

  /* ---------- Product page tabs (Material / Detail / Care) ---------- */
  $$('[data-tab]').forEach(function(btn){
    if (btn._tabBound) return;
    btn._tabBound = true;
    btn.addEventListener('click', function(e){
      e.preventDefault();
      var target = btn.dataset.tab;
      $$('[data-tab]').forEach(function(b){ b.classList.toggle('active', b.dataset.tab === target); });
      $$('[data-tab-panel]').forEach(function(p){ p.classList.toggle('active', p.dataset.tabPanel === target); });
    });
  });

  /* ---------- Filter drawer ---------- */
  var fdrawer = $('#filter-drawer');
  function openFilter(){
    if (!fdrawer) return;
    fdrawer.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeFilter(){
    if (!fdrawer) return;
    fdrawer.classList.remove('open');
    document.body.style.overflow = '';
  }
  $$('[data-filter-open]').forEach(function(b){ b.addEventListener('click', openFilter); });
  $$('[data-filter-close]').forEach(function(b){ b.addEventListener('click', closeFilter); });
  var fOverlay = $('.fd-overlay');
  if (fOverlay) fOverlay.addEventListener('click', closeFilter);

  /* ---------- Info modal (Size guide / Material / Detail / Care) ---------- */
  var imodal = $('#info-modal');
  var imTitle = $('#im-title');
  var imBody = $('#im-body');
  function openInfo(title, html){
    if (!imodal) return;
    if (imTitle) imTitle.textContent = title;
    if (imBody) imBody.innerHTML = html;
    imodal.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeInfo(){
    if (!imodal) return;
    imodal.classList.remove('open');
    document.body.style.overflow = '';
  }
  $$('[data-info-open]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var title = btn.dataset.infoTitle || '';
      var src = btn.dataset.infoSrc;
      var html = src ? (document.getElementById(src) || {}).innerHTML || '' : '';
      openInfo(title, html);
    });
  });
  $$('[data-info-close]').forEach(function(b){ b.addEventListener('click', closeInfo); });
  var iOverlay = $('.im-overlay');
  if (iOverlay) iOverlay.addEventListener('click', closeInfo);

  /* ---------- Styled Together carousel ---------- */
  function initStCarousel(){
    var scroller = $('.st-scroller');
    var prev = $('[data-st-prev]');
    var next = $('[data-st-next]');
    if (!scroller) return;
    function updateBtn(){
      if (prev) prev.disabled = scroller.scrollLeft <= 4;
      if (next) next.disabled = scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 4;
    }
    scroller.addEventListener('scroll', updateBtn, { passive: true });
    updateBtn();
    if (prev) prev.addEventListener('click', function(){
      scroller.scrollBy({ left: -scroller.clientWidth * 0.9, behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function(){
      scroller.scrollBy({ left: scroller.clientWidth * 0.9, behavior: 'smooth' });
    });
  }
  initStCarousel();

  /* ---------- Snap gallery: filters + lightbox ---------- */
  (function initSnap(){
    var grid = $('[data-snap-grid]');
    if (!grid) return;

    /* Filters */
    var filterButtons = $$('[data-snap-filters] .snap-filter');
    filterButtons.forEach(function(btn){
      btn.addEventListener('click', function(){
        var filter = btn.dataset.filter;
        var type = btn.dataset.filterType;
        filterButtons.forEach(function(b){ b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        $$('.snap-card', grid).forEach(function(card){
          if (filter === 'all') { card.style.display = ''; return; }
          var val = type === 'season' ? card.dataset.season : card.dataset.style;
          card.style.display = (val === filter) ? '' : 'none';
        });
      });
    });

    /* Lightbox */
    var lb = $('#snap-lightbox');
    if (!lb) return;
    var slImage = lb.querySelector('.sl-image');
    var slCreator = lb.querySelector('[data-sl-creator]');
    var slCaption = lb.querySelector('[data-sl-caption]');
    var slProducts = lb.querySelector('[data-sl-products]');

    /* Same money helper as the outer scope — Shopify JSON prices are always in cents */
    function money(cents){
      var symbol = window.NOMAD_CURRENCY_SYMBOL || '$';
      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      var zeros = ['IDR','JPY','KRW','VND','CLP','ISK','CRC','HUF','TWD','KMF','PYG','RWF','UGX','XAF','XOF','XPF','BIF','DJF','GNF','MGA'];
      var isZero = zeros.indexOf(currency) > -1;
      var major = Number(cents) / 100;
      var formatted = isZero
        ? Math.round(major).toLocaleString('en-US').replace(/,/g, '.')
        : (major % 1 === 0
            ? major.toLocaleString('en-US')
            : major.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
      return symbol + ' ' + formatted;
    }

    function openSnap(snapId){
      var scriptTag = document.querySelector('[data-snap-data="' + snapId + '"]');
      if (!scriptTag) return;
      var data;
      try { data = JSON.parse(scriptTag.textContent); } catch(e){ return; }

      slImage.src = data.image || '';
      slImage.alt = data.caption || data.creator_name || '';

      if (data.creator_name) {
        slCreator.innerHTML = data.creator_link
          ? '<a href="' + data.creator_link + '" target="_blank" rel="noopener">' + data.creator_name + '</a>'
          : data.creator_name;
      } else slCreator.textContent = '';

      slCaption.textContent = data.caption || '';

      slProducts.innerHTML = (data.products || []).map(function(p){
        var addBtn = p.variant_id && p.available
          ? '<button type="button" class="slp-add" data-sl-add="' + p.variant_id + '" aria-label="Add ' + p.title + '">+</button>'
          : '<span class="slp-add slp-soldout" title="Sold out">✕</span>';
        return '' +
          '<div class="sl-product">' +
            '<a href="' + p.url + '" class="slp-thumb"><img src="' + p.image + '" alt="" loading="lazy"></a>' +
            '<div class="slp-info">' +
              '<a href="' + p.url + '" class="slp-name">' + p.title + '</a>' +
              '<div class="slp-price">' + money(p.price) + '</div>' +
            '</div>' +
            addBtn +
          '</div>';
      }).join('');

      /* Bind add buttons */
      slProducts.querySelectorAll('[data-sl-add]').forEach(function(btn){
        btn.addEventListener('click', function(){
          var vid = btn.dataset.slAdd;
          btn.disabled = true;
          fetch('/cart/add.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
          }).then(function(){
            btn.textContent = '✓';
            /* Refresh cart count */
            fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
              $$('[data-cart-count]').forEach(function(el){ el.textContent = cart.item_count > 0 ? cart.item_count : ''; });
            });
            setTimeout(function(){ btn.textContent = '+'; btn.disabled = false; }, 1200);
          });
        });
      });

      lb.classList.add('open');
      document.body.style.overflow = 'hidden';
    }

    function closeSnap(){
      lb.classList.remove('open');
      document.body.style.overflow = '';
    }

    $$('[data-snap-open]').forEach(function(card){
      card.addEventListener('click', function(e){
        e.preventDefault();
        openSnap(card.dataset.snapId);
      });
    });
    $$('[data-snap-close]').forEach(function(el){ el.addEventListener('click', closeSnap); });
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape' && lb.classList.contains('open')) closeSnap();
    });
  })();

  /* Floating dismissible banner */
  function initFloatingBanner(){
    document.querySelectorAll('[data-floating-banner]').forEach(function(el){
      var key = 'nomad_fb_dismissed_' + (el.dataset.key || 'default');
      try {
        if (localStorage.getItem(key) === '1') { el.remove(); return; }
      } catch(_){}
      var btn = el.querySelector('[data-fb-close]');
      if (!btn || btn._bound) return;
      btn._bound = true;
      btn.addEventListener('click', function(e){
        e.preventDefault();
        el.classList.add('is-dismissed');
        try { localStorage.setItem(key, '1'); } catch(_){}
        setTimeout(function(){ el.remove(); }, 300);
      });
    });
  }
  initFloatingBanner();

  /* Re-init on Shopify theme editor section reload */
  document.addEventListener('shopify:section:load', function(){
    initPGallery();
    initCardSwipe();
    updateWishUI();
    bindWishlist();
    initStCarousel();
    initFloatingBanner();
  });
})();
